import request from '@/router/axios'

export function getOSSResourceUrl(id) {
  return request({
    url: `/netdisc/aliyun/${id}`,
    method: 'get'
  })
}

export function getFileList(params) {
  return request({
    url: '/netdisc/nodes/page',
    method: 'GET',
    params: params
  })
}

export function addFile(data) {
  return request({
    url: '/netdisc/nodes',
    method: 'POST',
    data: data
  })
}

export function updateFile(data) {
  return request({
    url: '/netdisc/nodes',
    method: 'PUT',
    data: data
  })
}

export function deleteFile(ids) {
  return request({
    url: `/netdisc/nodes`,
    method: 'DELETE',
    params: {
      ids: ids
    }
  })
}

export function moveFiles(data) {
  return request({
    url: '/netdisc/nodes/move',
    method: 'POST',
    data: data
  })
}

export function sortFileByDrag(data) {
  return request({
      url: '/netdisc/nodes/sort',
      method: 'POST',
      data: data
  })
}